var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"infiniteScrollList"},[_vm._t("default"),_vm._v(" "),(!_vm.isFinished)?_c('div',{staticClass:"u-mt-30 u-mb-30"},[_c('ProgressCircular',{attrs:{"size-type":"small","is-center":""}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }